import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { Loader } from '../ui/Loader';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, token, isLoading, checkAuth } = useAuthStore();
  const location = useLocation();
  const [hydrated, setHydrated] = useState(
    () => useAuthStore.persist?.hasHydrated?.() ?? true
  );

  useEffect(() => {
    const unsub = useAuthStore.persist?.onFinishHydration?.(() => {
      setHydrated(true);
      checkAuth();
    });
    if (useAuthStore.persist?.hasHydrated?.()) {
      setHydrated(true);
      checkAuth();
    }
    return () => {
      if (typeof unsub === 'function') unsub();
    };
  }, [checkAuth]);

  if (!hydrated || (isLoading && (token || localStorage.getItem('auth_token')))) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <Loader />
      </div>
    );
  }

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
